import React, { useState } from 'react';
import { api, tokens } from '../lib/api.js';
import { Alert, Field } from '../components/ui.jsx';

/** Shown when an administrator issued a temporary password. Nothing else works until it is replaced. */
export default function ForcePasswordChange({ onDone }) {
  const [current, setCurrent] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    if (password.length < 10) return setError('Use at least ten characters.');
    if (password !== confirm) return setError('The two entries do not match.');
    setBusy(true);
    try {
      const res = await api.post('/api/auth/change-password', { current_password: current, new_password: password });
      // The old session ended with the change; carry on with the fresh tokens.
      tokens.set(res);
      onDone();
    } catch (err) { setError(err.message); } finally { setBusy(false); }
  };

  return (
    <div className="auth">
      <aside className="auth-art">
        <div className="inline"><div className="rail-mark">IV</div><b>InvIT</b></div>
        <h2>Choose your own password before you start.</h2>
        <div style={{ fontSize: 12.5, color: '#8f98a4' }}>
          The one you were given is temporary, and everything else stays locked until it is replaced.
        </div>
      </aside>
      <div className="auth-form">
        <form className="inner" onSubmit={submit}>
          <h1>Set your password</h1>
          <Alert>{error}</Alert>
          <Field label="Temporary password">
            <input type="password" autoComplete="current-password" value={current} autoFocus
              onChange={(e) => setCurrent(e.target.value)} required />
          </Field>
          <Field label="New password" hint="at least 10 characters">
            <input type="password" autoComplete="new-password" value={password}
              onChange={(e) => setPassword(e.target.value)} required />
          </Field>
          <Field label="Repeat it">
            <input type="password" autoComplete="new-password" value={confirm}
              onChange={(e) => setConfirm(e.target.value)} required />
          </Field>
          <button className="btn big" style={{ width: '100%', justifyContent: 'center' }} disabled={busy}>
            {busy ? 'Saving…' : 'Save and continue'}
          </button>
        </form>
      </div>
    </div>
  );
}
